import { Button, Modal, Text } from '@mantine/core';
import { FormattedMessage, useIntl } from 'react-intl';

import { ModalContent } from '@shipstation/client-common/components/modal-content';
import { ModalFooter } from '@shipstation/client-common/components/modal-footer';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import { messages } from './messages';

type PackingRecommendationWarningModalProps = {
  opened: boolean;
  onCancel: () => void;
  onProceed: () => void;
};

export const PackingRecommendationWarningModal = ({ opened, onCancel, onProceed }: PackingRecommendationWarningModalProps) => {
  const intl = useIntl();
  const zIndex = useMaxZ();

  return (
    <Modal
      onClose={onCancel}
      opened={opened}
      size='sm'
      title={
        <Text fw={600} fz='lg'>
          {intl.formatMessage(messages.warningModalTitle)}
        </Text>
      }
      zIndex={zIndex}
    >
      <ModalContent>
        <Text fz='sm'>
          <FormattedMessage {...messages.warningModalBody} />
        </Text>
      </ModalContent>
      <ModalFooter>
        <Button onClick={onCancel} variant='tertiary'>
          <FormattedMessage {...messages.warningModalCancel} />
        </Button>
        <Button onClick={onProceed} variant='primary'>
          <FormattedMessage {...messages.warningModalProceed} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};
